module.exports = __webpack_public_path__ + "img/shop.e2f887d4.jpg";